import pageMixin from 'app/web/mixins/page.js'
import { setCookie } from 'lib/tools/cookies'

export default {
  mixins: [pageMixin],
  methods: {
    toTeacherPage(
      { user_id, waytype, coupon_id, channel_flag },
      source,
      channelId = ''
    ) {
      if (!user_id) {
        console.warn(`咨询师主页跳转没有user_id`)
        return
      }
      // const { pageName } = this.$route.meta
      // if (source && pageName) {
      //   source = `${pageName}-${source}`
      // }
      // if (source) {
      //   source = require('js-base64').Base64.encodeURI(source)
      // }
      // const fromRouteName = this.$route.name || ''
      this.routerPushWithoutNav({
        path: `/consult/${user_id}.html`,
        query: {
          // source,
          waytype,
          coupon_id: coupon_id,
          cid: channelId,
          channel_flag: channel_flag || this.$route.query.channel_flag,
          bizChannelId: this.$route.query.bizChannelId || '' // b端标识
          // fromRouteName
        }
      })
    },
    setCookie() {
      if (this.$isServer) return
      // #2319 【咨询】内部渠道标识优化
      const { channel_flag, cid, channel_id, share_user_id } = this.$route.query

      if (channel_flag) {
        setCookie({
          key: 'zixun_channel_flag',
          value: channel_flag,
          timeMinSec: 24 * 60 * 60 * 1000,
          domain: document.domain.split('.').slice(-2).join('.')
        })
      }

      if (cid || channel_id) {
        setCookie({
          key: 'consult_cooperation_channel',
          value: cid || channel_id,
          timeMinSec: 24 * 60 * 60 * 1000,
          domain: document.domain.split('.').slice(-2).join('.')
        })
      }

      if (typeof share_user_id !== 'undefined') {
        setCookie({
          key: 'share_user_id',
          value: share_user_id,
          timeMinSec: 24 * 60 * 60 * 1000,
          domain: document.domain.split('.').slice(-2).join('.')
        })
      }
    },
    async toOrderList() {
      const { cid } = this.$route.query
      if (this.$platform.isYixinliApp) {
        this.$bridge.gotoConsultOrderPage()
      } else {
        await this.$store.dispatch('getUserInfo')
        if (!this.isLogin) {
          this.toLogin()
          return
        }
        let role = 'user'
        if (this.consultTeacherInfo) {
          role = 'teacher'
        }
        this.routerPush(
          `https://static.xinli001.com/msite/index.html#/consult-list-${role}?cid=${
            cid || ''
          }`
        )
      }
    },
    // 半价、今明、学生优惠、满减专区  filterBar click
    onConsultingFilterClickTrack(options = {}, selectOption = {}) {
      try {
        let params = {
          filter_item: [],
          filter_item_direction: '',
          filter_item_way: '',
          filter_item_price: '',
          filter_item_gender: '',
          filter_item_is_preconsult: '否',
          page_title: this.$route.meta.pageName || ''
        }
        const {
          way_type,
          tag,
          price,
          gender,
          pre_consult,
          province,
          city,
          district
        } = options
        const { waytypes, tags, prices, genders } = selectOption

        if (way_type) {
          params.filter_item_way = waytypes.find(v => v.value === way_type).name
          params.filter_item.push('咨询方式')
        }
        if (province) {
          params.filter_item_area = province
          if (city) {
            params.filter_item_area += `-${city}`
          } else {
            params.filter_item_area += `-全部`
          }
          if (district) {
            params.filter_item_area += `-${district}`
          }
          params.filter_item.push('地区')
        }
        if (tag) {
          const res = tags.find(v => v.value === tag)
          params.filter_item_direction = res.name
          params.filter_item.push('咨询方向')
        }
        if (price) {
          const res = prices.find(v => v.value === price)
          params.filter_item_price = res.name
          params.filter_item.push('价格')
        }
        if (gender) {
          params.filter_item_gender = genders.find(v => v.value === gender).name
          params.filter_item.push('性别')
        }
        if (pre_consult) {
          params.filter_item_is_preconsult = '已开通'
          params.filter_item.push('是否预购通')
        }

        params.filter_item = [...new Set(params.filter_item)]
        this.$trackEvent('consulting_page_filter_click', params)
      } catch (error) {
        console.log(error)
      }
    }
  },
  created() {
    this.setCookie()
  },
  computed: {
    flag() {
      const { channel_flag } = this.$route.query
      return channel_flag
    },
    isLogin() {
      return this.$store.getters.isLogin
    }
  },
  filters: {
    blur(img) {
      if (!img) return img
      img = img.replace('!120', '')
      return (
        img.split('?')[0] + `?x-oss-process=image/resize,w_200/blur,r_30,s_30`
      )
    }
  }
}
